var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ma-2 mr-4",attrs:{"outlined":"","small":"","tile":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v("fas fa-arrow-left")]),_vm._v(" Назад ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }